import {
  ShieldCheck,
  Sparkles,
  Feather,
  Heart,
  Leaf,
  Droplet,
  Wheat,
  Sun,
} from "lucide-react";

const MAP = { ShieldCheck, Sparkles, Feather, Heart, Leaf, Droplet, Wheat, Sun };

export const DynIcon = ({ name, className }) => {
  const Icon = MAP[name] || Sparkles;
  return <Icon className={className} />;
};
